// removed by extract-text-webpack-plugin
module.exports = {"header":"Table-header-JC20b"};


//////////////////
// WEBPACK FOOTER
// ./modules/issFrontend/styles/Table.styl
// module id = ./modules/issFrontend/styles/Table.styl
// module chunks = 1